import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function eventReducer(state = initialState.events, action) {
    switch (action.type) {
        case types.PUSH_ERROR_EVENT:
            return Object.assign({}, state, {
                error: [action.data],
                success: [],
                warning: []
            });

        case types.PUSH_SUCCESS_EVENT:
            return Object.assign({}, state, {
                error: [],
                success: [action.data],
                warning: []
            });

        case types.PUSH_WARNING_EVENT:
          return Object.assign({}, state, {
              error: [],
              success: [],
              warning: [action.data]
          });

        default:
             return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/eventReducer.js
 **/